// removed by extract-text-webpack-plugin
module.exports = {"CheckBoxGroup":"CheckBoxGroup__CheckBoxGroup___18xgX","CheckBoxWrapper":"CheckBoxGroup__CheckBoxWrapper___2EhCi","InputCheckBox":"CheckBoxGroup__InputCheckBox___12zKT","CheckBoxWrapperCompact":"CheckBoxGroup__CheckBoxWrapperCompact___1BVcQ","requiredStar":"CheckBoxGroup__requiredStar___1B7BX","message":"CheckBoxGroup__message___2ZJZX","messageShow":"CheckBoxGroup__messageShow___15Fma"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicComponents/CheckBoxGroup/CheckBoxGroup.less
// module id = 1330
// module chunks = 0 1